import { CloudAPI } from '../../../shared/helpers/transport/cloud-api/types';
import { ArtifactRecipient } from '../features/fetching/types';

export const convertRecipient = ({
    display_name,
    email,
    role,
}: CloudAPI.ConferenceArtifacts.Recipient): ArtifactRecipient => ({
    displayName: display_name,
    email: email || null,
    role,
});
